import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, Loader, Login, Page} from '@blesk-frontend/ui';
import {Link} from '@tanstack/react-router';
import {useLayoutEffect} from 'react';

import {useAppPlatform} from '@/hooks';
import {sendEvent} from '@/libs/analytics';

export const AuthAppPage = () => {
  const {token, updateRedirectUrl} = useBleskAuth();
  const {setWindowsStatus} = useAppPlatform();

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useLayoutEffect(() => {
    if (!token) {
      updateRedirectUrl('app');
      return;
    }

    sendEvent('auth/callback-windows');
    setWindowsStatus('installed');
    location.href = `blesk://auth?token=${token}`;
  }, [token, updateRedirectUrl]);

  return (
    <Page className="flex max-w-lg flex-col items-center justify-center gap-6 text-center">
      {token ? (
        <>
          <div className="flex flex-col items-center justify-center gap-3">
            <Login className="size-16 text-text-secondary" />
            <div className="text-text-primary text-title-h2">Авторизация выполнена</div>
            <div className="text-paragraph-lg text-text-secondary">
              Приложение привязано к вашему аккаунту
            </div>
          </div>
          <Link to="/">
            <Button className="px-6 py-3">Мои инструкции</Button>
          </Link>
        </>
      ) : (
        <div className="text-text-secondary">
          <Loader size={24} />
        </div>
      )}
    </Page>
  );
};
